export enum SortType {
    LOWESTPRICE = "lowestPrice",
    MAXIMUMPRICE = "maximumPrice",
    NEWPRODUCTS = "newProducts",
    PRIORITYSORT = "prioritySort"                 
}